import React, { Component } from 'react'

import Aux from '../../../hoc/ReactAux/ReactAux'
import ReactModal from 'react-modal'

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
  },
  overlay: {
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)'
  }
}

class ModalError extends Component {
  render() {

    if (!this.props.showModal) {
      return null
    }

    return (
      <Aux>
        <ReactModal
          isOpen={this.props.showModal}
          style={customStyles}
          onRequestClose={this.props.closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          contentLabel="Example Modal">
          <div style={this.props.style} id="lb-error" className="lb-geral lb-error_ mfp-bg-login error-popup-block  lb-centralizar singup zoom-anim-dialog">
            <div className="lb-padrao-singup6 mfp-content-login modal-content">
              <button type="button" onClick={this.props.closeModal} className="bt-close mfp-close lb-fechar fa fa-times" />
              <div className="check-mark">
                <img src={require('../../../img/error-mark.png')} alt="error" />
              </div>
              <div style={this.props.styleContent} className="lb-content">
                <span className="order">
                  <strong>Oh No!</strong>
                  <br />
                  {this.props.errorMessage}
                </span>
                {!!this.props.actionButton ?
                  (
                    <a onClick={this.props.actionButton} className="bt">
                      {this.props.actionButtonTitle}
                    </a>
                  ) : null
                }
              </div>
            </div>
          </div>
        </ReactModal>
      </Aux>
    )
  }
}



export default ModalError



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalError.js